// side of dropdown image gallery swiper
var ddBottomSwiper = new Swiper(".dd-swiperBottom", {
  loop: false,
  spaceBetween: 10,
  slidesPerView: 6,
  freeMode: true,
  watchSlidesProgress: true,
  on: {
    init: function () {
      previousActiveIndex = this.activeIndex;
    },
    click: function () {
      // console.log("this.activeIndex",this.activeIndex)
      // console.log("this.clickedIndex",this.clickedIndex)
      // console.log("previousActiveIndex",previousActiveIndex)

      if (this.clickedIndex < previousActiveIndex) {
        // console.log("Left");
        this.slideTo(this.clickedIndex - 1, 300, true);
        // console.log(this.clickedIndex - 1);
      } else {
        this.slideTo(this.clickedIndex, 300, true);
      }
      previousActiveIndex = this.clickedIndex;
      // console.log("-----------",)
    },
  },
});

var ddTopSwiper = new Swiper(".dd-swiperTop", {
  loop: true,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: ddBottomSwiper,
  },
});

const shareImgProduct = document.querySelectorAll(".share_img_product");
if (!navigator.share) {
  shareImgProduct.forEach((each) => (each.style.display = "none"));
} else {
  shareImgProduct.forEach((each) => {
    each.addEventListener("click", (e) => {
      e.preventDefault();
      const shareData = {
        title: "Pedal Commander",
        text: "Hey, I just stumbled upon {{product.title}}. It is a performance part that will remove the acceleration lag from the throttle. Check it out!",
        url: `${window.location.href}`,
      };
      navigator
        .share(shareData)
        .then(() => {
          console.log("page was shared");
        })
        .catch((error) => {
          console.log(error);
        });
    });
  });
}

function customSmoothScroll(x) {
  window.scrollTo({
    top: x,
    behavior: "smooth",
  });
}

const xdBannerDropdownOpenId = document.querySelector(
  "#xdBannerDropdownOpenId"
);
function ddActions() {
  if (window.innerWidth < 768) customSmoothScroll(755);
}

xdBannerDropdownOpenId.addEventListener("click", ddActions);

// -------------------------------

const bottomDivider = document.querySelector(".pp-grid-parent");
const buyNowButtonForMobile = document.querySelector(".buyNow-buy-now-mobile");
const fixedBannerButton = document.querySelector(".fixed-banner-btn");

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting && window.innerWidth < 768) {
        // Banner görünmüyor ve ekran genişliği 768px'in altında ise
        buyNowButtonForMobile.style.display = "block";
        fixedBannerButton.style.display = "flex";
        // console.log("mobile buy now göster")
      } else {
        // Banner görünüyor veya ekran genişliği 768px'in üstünde ise
        buyNowButtonForMobile.style.display = "none";
        // console.log("mobile buy now gizle")
      }
    });
  },
  { threshold: 0 }
);

// Observer'ı banner elementine bağla
observer.observe(bottomDivider);

// Pencere boyutu değiştiğinde kontrol et
window.addEventListener("resize", () => {
  if (!observer) return;
  if (window.innerWidth < 768) {
    observer.observe(bottomDivider);
  } else {
    observer.unobserve(bottomDivider);
    buyNowButtonForMobile.style.display = "none";
  }
});
// ---------------------------

// tavk.to app
if (window.innerWidth < 1000) styleTawkFunc();

function styleTawkFunc() {
  const tawkWidgetInterval = setInterval(getTawkWidgetInterval, 1000);
  const clearTawkInterval = setInterval(clearTawkWidgetInterval, 10000);

  function getTawkWidgetInterval() {
    // console.log("tawk func run")
    let tawkWidgetVisibleIframe = document.querySelector(".richpanel-micro");

    if (tawkWidgetVisibleIframe) {
      // console.log("tawkWidgetVisibleIframe.classList.contains('rp-micro-app-hide')",tawkWidgetVisibleIframe.classList.contains('rp-micro-app-hide'))
      if (!tawkWidgetVisibleIframe.classList.contains("rp-micro-app-hide")) {
        fixedBannerButton.style.justifyContent = "left";
        document.querySelector(".fixed-banner-btn button").style.width = "65%";
        document.querySelector(".fixed-banner-btn button").style.fontSize =
          "25px";
        console.log("tawk render edildi ve interval del");
        clearInterval(tawkWidgetInterval);
      }
    }
  }

  function clearTawkWidgetInterval() {
    clearInterval(tawkWidgetInterval);
    clearInterval(clearTawkInterval);
    // console.log("tawk render edilmedi 10 sn sonra interval del")
  }
}

// IMAGE ZOOM
const sliderImages = document.querySelectorAll(".dd-swiperTop .swiper-slide");
sliderImages.forEach((image) =>
  image.addEventListener("click", handleImageClick)
);
let isZoomStarted = false;
async function handleImageClick() {
  if (isZoomStarted) return;
  isZoomStarted = true;
  const viewportOffset = this.getBoundingClientRect();
  const modalBox = createModalBox();
  const imageClone = await cloneImage(this, modalBox, viewportOffset);
  document.body.style.overflow = "hidden";

  document.body.append(modalBox);
}

async function cloneImage(el, box, viewportOffset) {
  const { innerWidth, innerHeight } = window;
  const imageEl = el.querySelector("img");
  const imageSource = new URL(imageEl.src);
  const params =
    "?" +
    (innerWidth > innerHeight
      ? `height=${calculatePercentage(90, innerHeight)}`
      : `width=${calculatePercentage(90, innerWidth)}`);
  const imageUrl = imageSource.pathname + params;

  // Fetch the image
  await fetch(imageUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.blob();
    })
    .then((blob) => {
      const imageClone = document.createElement("img");
      imageClone.src = URL.createObjectURL(blob);
      imageClone.classList.add("cloned-image");

      const { left, top, width, height } = viewportOffset;
      imageClone.style = `width:${width}px;height:${height}px;left:${left}px;top:${top}px;`;
      box.append(imageClone);

      requestAnimationFrame(() => {
        if (innerWidth > innerHeight) {
          imageClone.style = `width:auto;height:90%;left:50%;top:50%;transform:translateY(-50%) translateX(-50%);`;
        } else {
          imageClone.style = `width:90%;height:auto;left:50%;top:50%;transform:translateY(-50%) translateX(-50%);`;
        }
      });
    })
    .catch((error) => {
      console.error("There was a problem with the fetch operation:", error);
    });
}

function createModalBox() {
  const modalBox = document.createElement("div");
  const cross = document.createElement("a");
  cross.classList.add("zoom-container-cross");
  modalBox.classList.add("zoom-container");
  modalBox.append(cross);

  modalBox.dataset.closeModal = true;
  cross.dataset.closeModal = true;

  modalBox.classList.add("opened");
  modalBox.onclick = (e) => {
    if (e.target.dataset.closeModal) {
      closeModalBox(modalBox);
    }
  };
  return modalBox;
}
function closeModalBox(modalBox) {
  modalBox.classList.remove("opened");
  setTimeout(() => {
    document.body.style.overflow = "";
    modalBox.remove();
    isZoomStarted = false;
  }, 500);
}

function calculatePercentage(x, number) {
  return (x / 100) * number;
}
// IMAGE ZOOM
